export default __webpack_public_path__ + "static/media/events-selected.cfcc724b.svg";